<template>
  <div class="main">
    <div class="title-bar">
      <h1 class="mb-1">Edit Course Enrollment</h1>
      <h4 class="text-primary mb-3">Enrollment ID: {{ enrollment.id }}</h4>
      <a class="btn-back" :href="backLink">
        <span class="icon icon-arrow-left"></span>
        <span class="text">Back to List</span>
      </a>
    </div>

    <div class="content p-4">
      <transition name="fade">
        <Alert v-if="hasAlert" :alert="alert" />
      </transition>

      <div class="row">
        <div class="col-12 mb-5 col-xl-4 mb-xl-0">
          <EnrollmentDetailsPane :enrollment="enrollment" :hide-close="true" />
        </div>
        <div class="col-12 col-xl-8 mb-5 mb-xl-0">
          <FormWrapper :action="formAction" method="PUT">
            <div class="row">
              <div class="col-12 mb-3 col-sm-6 col-lg-4 col-xl-3">
                <Field
	                type="select"
	                name="completion_status"
	                label="Completion Status"
	                v-model="completionStatus"
	                :options="completionStatuses"
	                :hide-select-empty-option="true" />
              </div>
              <div class="col-12 mb-3 col-sm-6 col-lg-4 col-xl-3">
                <Field
	                type="datepicker"
	                name="completed_at"
	                label="Completion Date"
	                :value="enrollment.completed_at"
	                :disabled="!isPassed" />
              </div>
              <div class="d-none d-lg-block col-lg-4 col-xl-6"></div>
	            <div class="col-md-6 col-12">
		            <Field
			            type="select"
			            name="enrollment_brand"
			            label="Brand"
			            :hide-select-empty-option="true"
			            :value="enrollment.brand.id"
		                :options="brandOptions" />
	            </div>
            </div>
            <div class="row mt-4">
              <div class="col-12 text-center text-lg-left">
                <button
	                type="submit"
	                class="btn btn-success w-75 mb-2 w-sm-auto mb-sm-0 mr-sm-2"
                >
                  Save Changes
                </button>
                <a :href="backLink" class="btn btn-danger w-75 w-sm-auto"
                >Cancel & Exit</a
                >
              </div>
            </div>
          </FormWrapper>

          <template v-if="!!onlineSession">
            <hr />
            <EditorGroupToggle
	            label="Most Recent Online Session"
	            target="toggleGroupSession"
	            class="mb-4"
	            :collapsed="false"
            />
            <div id="toggleGroupSession" class="collapse show row">
              <div class="col-12 details-pane-table">
                <div class="row mb-2">
                  <div class="col-4 col-xl-3 col-attribute">Started on</div>
                  <div class="col-8 col-xl-9 col-value">
                    {{ onlineSession.created_at | moment("M/D/YYYY h:ma") }}
                  </div>
                </div>
                <div
	                v-for="log in onlineSession.logs"
	                :key="log.key"
	                class="row mb-2"
                >
                  <div class="col-4 col-xl-3 col-attribute">
                    {{ log.label }}
                  </div>
                  <div class="col-8 col-xl-9 col-value">{{ log.value }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 col-xl-3 col-attribute">No. of Views</div>
                  <div class="col-8 col-xl-9 col-value">
                    {{ enrollment.views }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import EnrollmentDetailsPane from "components/partials/Courses/EnrollmentDetailsPane";

export default {
	mixins: [DisplaysAlerts],
	components: {EnrollmentDetailsPane},
	props: {
		enrollment: {type: Object, required: true},
		completionStatuses: {type: Array, required: true},
		onlineSession: {type: Object},
		brandOptions: {type: Object},
	},
	data() {
		return {
			completionStatus: null,
		};
	},
	computed: {
		backLink() {
			return this.route("admin.courses.enrollments.index", {
				course: this.enrollment.enrollable_id,
			});
		},
		routeParam() {
			return {enrollment: this.enrollment.id};
		},
		formAction() {
			return this.route("admin.courses.enrollments.update", this.routeParam);
		},
		isPassed() {
			return this.completionStatus == this.$root.constants.COMPLETION_PASSED;
		},
	},
	created() {
		this.completionStatus = this.enrollment.completion_status;
	},
};
</script>